// Core imports
import * as React from 'react';
import i18n from 'src/translation/i18n';

// utils regex
import { emailcapsRegEx } from 'src/utils/RegexUtils';

class PackageNeverArrivedServiceInfo extends React.Component<IDamageServiceInfoProps, any> {
  constructor(props: IDamageServiceInfoProps) {
    super(props);
  }
  public render() {
    return (
      <div style={{ marginBottom: '10px'}}>
        <h4>{i18n.t('partClaim.Servicerinfo')}</h4>
        <div className="form-row row  ">
          <div className="form-group col-sm-12 col-md-3 col-lg-3 mb">
            <label className="form-control-placeholder" htmlFor="serviceremail" >
               {i18n.t('partClaim.serviceremail')}:
              <span className="required">*</span>
            </label>
            <input
              className={`form-control ${
                this.props.DamageErrorlistservice?.DamageservicerEmailError
                  ? 'is-invalid'
                  : this.props.DamageErrormsgshow &&
                    this.props.DamageservicerEmail.trim() === ''
                  ? 'form-control-error-border'
                  : ''
              }`}
              name="email"
              type="text"
              value={this.props.DamageservicerEmail}
              onChange={this.props.handleDamageserviceremail}
            />

            <span className="rp-warranty-input-error-internal">
              {this.props.DamageErrorlistservice?.DamageservicerEmailError ? (
                this.props.DamageservicerEmail === '' ? (
                  `${i18n.t('partClaim.reqfield')}`
                ) : this.props.DamageservicerEmail.length > 50 &&
                  !emailcapsRegEx.test(this.props.DamageservicerEmail) ? (
                  <>
                    <p>{i18n.t('partClaim.emailexceederror')}</p>
                    <p>{i18n.t('partClaim.emailerror')}</p>
                  </>
                ) : !emailcapsRegEx.test(this.props.DamageservicerEmail) ? (
                  `${i18n.t('partClaim.emailerror')}`
                ) : this.props.DamageservicerEmail.length > 50 ? (
                  <>
                    <p>{i18n.t('partClaim.emailexceederror')}</p>
                  </>
                ) : (
                  ''
                )
              ) : (
                ''
              )}
            </span>
          </div>
          <div className="form-group col-sm-12 col-md-3 col-lg-3 mb">
            <label className="form-control-placeholder" htmlFor="servicerPhone">
              {i18n.t('partClaim.servicerPhone')}:
            </label>
            <input
              className={`form-control ${
                this.props.DamageErrorlistservice?.DamageservicerPhoneError
                  ? 'is-invalid'
                  : ''
              }`}
              name="customer.servicephone"
              type="text"
              placeholder="xxx-xxx-xxxx"
              value={this.props.DamageservicerPhone}
              onChange={this.props.handleDamageservicerphone}
            />

            <span className="rp-warranty-input-error-internal">
              {this.props.DamageErrorlistservice?.DamageservicerPhoneError
                ? ` ${i18n.t('partClaim.phonerror')}`
                : ''}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default PackageNeverArrivedServiceInfo;

interface IDamageServiceInfoProps {
  DamageservicerEmail: string;
  DamageservicerPhone: string;
  DamageErrorlistservice: any;
  DamageErrormsgshow: boolean;
  handleDamageserviceremail: (event: any) => void;
  handleDamageservicerphone: (event: any) => void;
}
